export default "__VITE_ASSET__DsGomcUU__"